import "./chunk-6LOWPV43.js";

// src/assets/celebration-lines.lottie.json
var v = "4.8.0";
var meta = { g: "LottieFiles AE 1.1.0", a: "", k: "", d: "", tc: "" };
var fr = 29.9700012207031;
var ip = 0;
var op = 60.0000024438501;
var w = 220;
var h = 220;
var nm = "Achievement";
var ddd = 0;
var assets = [
  {
    id: "comp_0",
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Line",
        sr: 1,
        ks: {
          o: {
            a: 1,
            k: [
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.167], y: [0.167] },
                t: 0,
                s: [91]
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                t: 9,
                s: [100]
              },
              { t: 11.0000004480392, s: [0] }
            ],
            ix: 11
          },
          r: { a: 0, k: 0, ix: 10 },
          p: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 0.667 },
                o: { x: 0.167, y: 0.167 },
                t: 1,
                s: [172.75, 115.094, 0],
                to: [0, 0, 0],
                ti: [0, 0, 0]
              },
              {
                i: { x: 0.833, y: 0.833 },
                o: { x: 0.333, y: 0 },
                t: 2,
                s: [172.75, 115.094, 0],
                to: [0, 0, 0],
                ti: [0, 0, 0]
              },
              { t: 9.00000036657752, s: [207.812, 115.094, 0] }
            ],
            ix: 2
          },
          a: { a: 0, k: [66.5, 8.844, 0], ix: 1 },
          s: {
            a: 1,
            k: [
              {
                i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                o: { x: [0.167, 0.167, 0.167], y: [0.167, 0, 0] },
                t: 1,
                s: [4.935, 64.395, 100]
              },
              {
                i: { x: [0.833, 0.833, 0.833], y: [0.833, 1, 1] },
                o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                t: 2,
                s: [105, 64.395, 100]
              },
              { t: 9.00000036657752, s: [4.935, 64.395, 100] }
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: { a: 0, k: [36.039, 2.748], ix: 2 },
                p: { a: 0, k: [0, 0], ix: 3 },
                r: { a: 0, k: 20, ix: 4 },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
                o: { a: 0, k: 100, ix: 4 },
                w: { a: 0, k: 0, ix: 5 },
                lc: 1,
                lj: 1,
                ml: 4,
                bm: 0,
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [0.383642787559, 0.100305811564, 0.920174632353, 1],
                  ix: 4
                },
                o: { a: 0, k: 100, ix: 5 },
                r: 1,
                bm: 0,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: { a: 0, k: [84.52, 8.874], ix: 2 },
                a: { a: 0, k: [0, 0], ix: 1 },
                s: { a: 0, k: [100, 100], ix: 3 },
                r: { a: 0, k: 0, ix: 6 },
                o: { a: 0, k: 100, ix: 7 },
                sk: { a: 0, k: 0, ix: 4 },
                sa: { a: 0, k: 0, ix: 5 },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 1",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 30.0000012219251,
        st: 0,
        bm: 0
      }
    ]
  }
];
var layers = [
  {
    ddd: 0,
    ind: 1,
    ty: 0,
    nm: "Line Comp 1",
    refId: "comp_0",
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 314.699, ix: 10 },
      p: { a: 0, k: [110, 110, 0], ix: 2 },
      a: { a: 0, k: [110, 110, 0], ix: 1 },
      s: { a: 0, k: [100, 100, 100], ix: 6 }
    },
    ao: 0,
    w: 220,
    h: 220,
    ip: 0,
    op: 30.0000012219251,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 2,
    ty: 0,
    nm: "Line Comp 1",
    refId: "comp_0",
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 269.309, ix: 10 },
      p: { a: 0, k: [104, 110, 0], ix: 2 },
      a: { a: 0, k: [110, 110, 0], ix: 1 },
      s: { a: 0, k: [100, 100, 100], ix: 6 }
    },
    ao: 0,
    w: 220,
    h: 220,
    ip: 0,
    op: 30.0000012219251,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 3,
    ty: 0,
    nm: "Line Comp 1",
    refId: "comp_0",
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 223.338, ix: 10 },
      p: { a: 0, k: [110, 110, 0], ix: 2 },
      a: { a: 0, k: [110, 110, 0], ix: 1 },
      s: { a: 0, k: [100, 100, 100], ix: 6 }
    },
    ao: 0,
    w: 220,
    h: 220,
    ip: 0,
    op: 30.0000012219251,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 4,
    ty: 0,
    nm: "Line Comp 1",
    refId: "comp_0",
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 174.64, ix: 10 },
      p: { a: 0, k: [110, 110, 0], ix: 2 },
      a: { a: 0, k: [110, 110, 0], ix: 1 },
      s: { a: 0, k: [100, 100, 100], ix: 6 }
    },
    ao: 0,
    w: 220,
    h: 220,
    ip: 0,
    op: 30.0000012219251,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 5,
    ty: 0,
    nm: "Line Comp 1",
    refId: "comp_0",
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 132.248, ix: 10 },
      p: { a: 0, k: [110, 110, 0], ix: 2 },
      a: { a: 0, k: [110, 110, 0], ix: 1 },
      s: { a: 0, k: [100, 100, 100], ix: 6 }
    },
    ao: 0,
    w: 220,
    h: 220,
    ip: 0,
    op: 30.0000012219251,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 6,
    ty: 0,
    nm: "Line Comp 1",
    refId: "comp_0",
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 89.416, ix: 10 },
      p: { a: 0, k: [112.5, 110, 0], ix: 2 },
      a: { a: 0, k: [110, 110, 0], ix: 1 },
      s: { a: 0, k: [100, 100, 100], ix: 6 }
    },
    ao: 0,
    w: 220,
    h: 220,
    ip: 0,
    op: 30.0000012219251,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 7,
    ty: 0,
    nm: "Line Comp 1",
    refId: "comp_0",
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 38.34, ix: 10 },
      p: { a: 0, k: [110, 110, 0], ix: 2 },
      a: { a: 0, k: [110, 110, 0], ix: 1 },
      s: { a: 0, k: [100, 100, 100], ix: 6 }
    },
    ao: 0,
    w: 220,
    h: 220,
    ip: 0,
    op: 30.0000012219251,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 8,
    ty: 0,
    nm: "Line Comp 1",
    refId: "comp_0",
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 0, ix: 10 },
      p: { a: 0, k: [110, 110, 0], ix: 2 },
      a: { a: 0, k: [110, 110, 0], ix: 1 },
      s: { a: 0, k: [100, 100, 100], ix: 6 }
    },
    ao: 0,
    w: 220,
    h: 220,
    ip: 0,
    op: 30.0000012219251,
    st: 0,
    bm: 0
  }
];
var markers = [];
var celebration_lines_lottie_default = {
  v,
  meta,
  fr,
  ip,
  op,
  w,
  h,
  nm,
  ddd,
  assets,
  layers,
  markers
};
export {
  assets,
  ddd,
  celebration_lines_lottie_default as default,
  fr,
  h,
  ip,
  layers,
  markers,
  meta,
  nm,
  op,
  v,
  w
};
//# sourceMappingURL=celebration-lines.lottie-VE3Q4JPJ.js.map